export const UPDATE_QUESTIONAIRE_QUESTION = "UPDATE_QUESTIONAIRE_QUESTION"
export const UPDATE_QUESTIONAIRE_QUESTION_SUCCESSFUL = "UPDATE_QUESTIONAIRE_QUESTION_SUCCESSFUL"
export const UPDATE_QUESTIONAIRE_QUESTION_FAILED = "UPDATE_QUESTIONAIRE_QUESTION_FAILED"
export const UPDATE_QUESTIONAIRE_QUESTION_RESET = "UPDATE_QUESTIONAIRE_QUESTION_RESET"